function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.74463 4.61935h-17.489C.56324 4.61935 0 5.1826 0 5.87472v8.2503c0 .69239.56324 1.25563 1.25563 1.25563h17.489C19.43676 15.38065 20 14.8174 20 14.125V5.87473c0-.69214-.56324-1.25538-1.25537-1.25538zm-.25745.80478l-7.98026 4.97092-.0283.01939c-.24363.18233-.67065.18233-.91428 0l-8.07863-4.9903h17.00147zm.25745 9.15174h-17.489c-.2486 0-.45085-.20225-.45085-.45086v-8.1756l8.29325 5.121c.26092.18915.59232.28399.92345.28399.33166 0 .66305-.09484.92398-.2845l8.24976-5.13859v8.1937c0 .24861-.20224.45086-.4506.45086z"
});

var SvgIconSent = function SvgIconSent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-sent.2c1db618.svg";
export { ForwardRef as ReactComponent };